import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as userProfileService from 'services/user';
import * as permissionService from 'services/roles-security';
import * as memberMaintenanceServices from 'services/memberMaintenance';

const getUserProfileHeaderQueryKey = (userId) => {
  return ['get-user-profile-header', Number(userId)];
};
const getUserProfileHeaderQueryKeyAll = () => {
  return ['get-user-profile-header'];
};

export const usePublicSpecification = (memberId, options = {}) =>
  useQuery({
    queryKey: ['get-public-specification', memberId],
    queryFn: () =>
      userProfileService.getPublicSpecification({ MemberId: memberId }),
    select: (res) => res?.data?.[0]?.specification || [],
    ...options,
  });

export const useSuggestionUsers = (searchText = '', memberId, options) =>
  useQuery({
    queryKey: ['get-suggestion-users', searchText, memberId],
    queryFn: () =>
      userProfileService.getSuggestionUsers({
        SearchText: searchText,
        MemberId: memberId,
      }),
    select: (res) => res?.data?.suggestionUsers || [],
    ...options,
  });

export const useUserRolesLandingPages = (userId, options = {}) =>
  useQuery({
    queryKey: ['get-user-roles', userId],
    enabled: !!userId,
    queryFn: () => permissionService.getUserRoles({ UserId: userId }),
    ...options,
  });

export const useFilteredLandingPages = (memberId, options = {}) =>
  useQuery({
    queryKey: ['get-member-security-access', memberId],
    enabled: !!memberId,
    queryFn: () =>
      memberMaintenanceServices.getMemberSecurityAccess({
        memberId,
      }),
    ...options,
  });

export const useGetUserProfileHeaderInfo = (userId, options = {}) => {
  const queryClient = useQueryClient();

  const queries = useQuery({
    queryKey: getUserProfileHeaderQueryKey(userId),
    enabled: !!userId,
    queryFn: async () => {
      const res = await userProfileService.getUserProfileHeader({
        userId: userId,
      });
      if (res?.isSuccess) {
        return res?.data;
      }
    },
    ...options,
  });

  const invalidateUserProfileHeader = (userId) => {
    queryClient.invalidateQueries({
      queryKey: userId
        ? getUserProfileHeaderQueryKey(userId)
        : getUserProfileHeaderQueryKeyAll(),
    });
  };
  return {
    ...queries,
    invalidateUserProfileHeader,
  };
};
